/**
 * Maps internal status values to user-friendly display names
 * @param status - The internal status value (e.g., 'published', 'qa', 'draft', 'archived')
 * @returns The user-friendly display name (e.g., 'Final', 'QA', 'Draft', 'Archived')
 */
export function getStatusDisplayName(status: string | undefined | null): string {
  if (!status) return 'Unknown'

  const statusMap: Record<string, string> = {
    published: 'Final',
    qa: 'QA',
    draft: 'Draft',
    archived: 'Archived',
  }

  return statusMap[status.toLowerCase()] || status
}

